import { useEffect, useState } from "react";
import PageHeader from "../pageHeader/pageheader";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
} from "antd";
import { API } from "../../config/api";
import { POST } from "../../utils/apicalls";
import Type from "../employee/helpers/type.json";
import DataTable from "./table";

function Employee() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5); // Define the page size
  const [data, setData] = useState<any>([]);
  const [meta, setMeta] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const filterEmployee = async (values: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        type: values.type,
        fullName: values.fullName,
        status: true,
      };
      const url = API.FILTER_EMPLOYEE;
      const response: any = await POST(url, obj);
      setData(response?.data);

      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchHrEmployee = async (page: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page: page,
        take: 5,
      };
      const url = API.PAGENATION_EMPLOYEE;
      const response: any = await POST(url, obj);
      setData(response?.data);

      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchHrEmployee(page);
  }, [page]); // Fetch data on page or pageSize change

  const submitHandler = async (values: any) => {
    try {
      let obj = {
        type: values.type,
        firstName: values.firstName,
        lastName: values.lastName,
        fullName: values.fullName,
        userName: values.userName,
        password: values.password,
        email: values.email,
        officeEmail: values.officeEmail,
        phone: values.phone,
        altPhone: values.altPhone,
        gender: values.gender,
        department: values.department,
        wrok_status: values.wrok_status,
        dob: values.dob,
        hireDate: values.hireDate,
        address: values.address,
        status: values.status,
        accountNo: values.accountNo,
        bankName: values.bankName,
        ifsc: values.ifsc,
        branch: values.branch,
        accountName: values.accountName,
        salary: Number(values.salary),
        id_Type: values.id_Type,
        id_Number: values.id_Number,
        id_Image1: values.id_Image1,
        bloodGroup: values.bloodGroup,
      };

      setIsLoading(true);
      const api = API.EMPLOYEE_CREATE;
      const postRequest: any = await POST(api, obj);

      if (postRequest.status) {
        notification.success({ message: "Employee created successfully!" });
        setIsLoading(false);
        setIsModalOpen(false);
        form.resetFields();
        fetchHrEmployee(page);
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  return (
    <div>
      <PageHeader>
        <Button
          type="primary"
          onClick={showModal}
          style={{ marginRight: "10px" }}
        >
          Create Employee
        </Button>
      </PageHeader>
      <div>
        <Card>
          <Form form={form} onFinish={filterEmployee} layout="vertical">
            <Row gutter={16} align="middle">
              <Col sm={6}>
                <Form.Item name="type" label="Type">
                  <Select placeholder="Select Type" allowClear>
                    {Type?.map((des) => (
                      <Select.Option key={des.value} value={des.value}>
                        {des.title}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col sm={6}>
                <Form.Item name="fullName" label="First Name">
                  <Input placeholder="First Name" allowClear />
                </Form.Item>
              </Col>

              <Col sm={6}>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                    block
                  >
                    Search
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
        <Modal
          title="Create Employee"
          visible={isModalOpen}
          onCancel={handleCancel}
          width={1000}
          footer={false}
        >
          <Form form={form} onFinish={submitHandler} layout="vertical">
            <Row gutter={16}>
              <Col sm={6}>
                <Form.Item
                  name="type"
                  label="Type"
                  rules={[{ required: true, message: "Please select type" }]}
                >
                  <Select placeholder="Select Type">
                    {Type?.map((des) => (
                      <Select.Option key={des.value} value={des.value}>
                        {des.title}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="firstName"
                  label="First Name"
                  rules={[{ required: true, message: "Enter First Name" }]}
                >
                  <Input placeholder="First Name" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="lastName"
                  label="Last Name"
                  rules={[{ required: true, message: "Enter Last Name" }]}
                >
                  <Input placeholder="Last Name" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="fullName"
                  label="Full Name"
                  rules={[{ required: true, message: "Enter Full Name" }]}
                >
                  <Input placeholder="Full Name" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="userName"
                  label="Username"
                  rules={[{ required: true, message: "Enter Username" }]}
                >
                  <Input placeholder="Username" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="password"
                  label="Password"
                  rules={[{ required: true, message: "Enter Password" }]}
                >
                  <Input.Password placeholder="Password" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    {
                      required: true,
                      type: "email",
                      message: "Enter valid Email",
                    },
                  ]}
                >
                  <Input placeholder="Email" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="officeEmail"
                  label="Office Email"
                  rules={[
                    {
                      required: true,
                      type: "email",
                      message: "Enter valid Office Email",
                    },
                  ]}
                >
                  <Input placeholder="Office Email" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="phone"
                  label="Phone"
                  rules={[{ required: true, message: "Enter Phone Number" }]}
                >
                  <Input placeholder="Phone" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="altPhone" label="Alternate Phone">
                  <Input placeholder="Alternate Phone" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="gender"
                  label="Gender"
                  rules={[{ required: true, message: "Select Gender" }]}
                >
                  <Select placeholder="Select Gender">
                    <Select.Option value="Male">Male</Select.Option>
                    <Select.Option value="Female">Female</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="department"
                  label="Department"
                  rules={[{ required: true, message: "Enter Department" }]}
                >
                  <Input placeholder="Department" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="work_status" label="Work Status">
                  <Input placeholder="Work Status" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="dob"
                  label="Date of Birth"
                  rules={[{ required: true, message: "Select Date of Birth" }]}
                >
                  <DatePicker />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="hireDate"
                  label="Hire Date"
                  rules={[{ required: true, message: "Select Hire Date" }]}
                >
                  <DatePicker />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="address"
                  label="Address"
                  rules={[{ required: true, message: "Enter Address" }]}
                >
                  <Input.TextArea placeholder="Address" />
                </Form.Item>
              </Col>
              {/* <Col sm={6}>
                <Form.Item
                  name="status"
                  label="Status"
                  rules={[{ required: true, message: "Select status" }]}
                >
                  <Select placeholder="Select status">
                    <Select.Option value={true}>Active</Select.Option>
                    <Select.Option value={false}>InActive</Select.Option>
                  </Select>
                </Form.Item>
              </Col> */}
              <Col sm={6}>
                <Form.Item name="accountNo" label="Account Number">
                  <Input placeholder="Account Number" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="bankName" label="Bank Name">
                  <Input placeholder="Bank Name" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="ifsc" label="IFSC Code">
                  <Input placeholder="IFSC Code" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="branch" label="Branch">
                  <Input placeholder="Branch" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="accountName" label="Account Name">
                  <Input placeholder="Account Name" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="salary"
                  label="Salary"
                  rules={[{ required: true, message: "Enter Salary" }]}
                >
                  <Input placeholder="Salary" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="id_Type" label="ID Type">
                  <Input placeholder="ID Type" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="id_Number" label="ID Number">
                  <Input placeholder="ID Number" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="id_Image1" label="ID Image">
                  <Input placeholder="ID Image" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="bloodGroup" label="Blood Group">
                  <Input placeholder="Blood Group" />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                    block
                  >
                    Create Employee
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </div>

      <div>
        <DataTable
          dataSource={data}
          isLoading={isLoading}
          meta={meta}
          // onPageChange={(newPage: number, newPageSize: number) => {
          //   setPage(newPage);
          //   setPageSize(newPageSize);
          // }}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: meta?.total_count,
            onChange: (page: any, pageSize: any) => {
              setPage(page);
              setPageSize(pageSize);
            },
          }}
        />
      </div>
    </div>
  );
}

export default Employee;
